import { atom } from 'recoil';

export const IsReportsModalState = atom<boolean>({
  key: 'is-reports-modal',
  default: false,
});

export const IsGenerateReportsLoadingState = atom<boolean>({
  key: 'is-generate-report-loading',
  default: false,
});

export const SelectedDeleteReportState = atom<string>({
  key: 'selected-delete-report-state',
  default: '',
});
